import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RespuestaC = ({ aBoleto, onClose }) => {
    const { t } = useTranslation();

    useEffect(() => {
        // Prevent background scrolling when modal is open
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    if (!aBoleto || aBoleto.length === 0) return null;

    // Colores basados en lógica original
    const getStatusColor = (estatusId) => {
        switch (estatusId) {
            case "A": return "#D25A2F";
            case "C": return "#DF922E";
            case "E": return "#A9CAC9";
            case "N": return "#6CA9B0";
            case "P": return "#306795";
            case "R": return "#332e2d";
            case "X": return "#D7D8DC";
            default: return "#CD171A"; // default red
        }
    };

    // Orden cronológico descendente (más reciente arriba)
    const reversedBoleto = [...aBoleto].reverse();

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.65)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(5px)'
        }}>
            <div style={{
                fontFamily: "'Lato', sans-serif",
                background: '#fcfcfc',
                width: '95%',
                maxWidth: '750px',
                maxHeight: '85vh',
                borderRadius: '16px',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Header Premium */}
                <div style={{ 
                    padding: '24px 30px', 
                    background: 'linear-gradient(135deg, #cd171a 0%, #a01012 100%)',
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                }}>
                    <div>
                        <span style={{color: '#ffb3b3', fontSize: '0.95rem', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase'}}>{t('respuesta.detalles', 'Detalles de solicitud')}</span>
                        <h3 style={{ margin: '4px 0 0 0', fontSize: '1.8rem', color: '#ffffff', fontWeight: '800' }}>
                            #{aBoleto[0].SolicitudID}
                        </h3>
                    </div>
                    <button 
                        onClick={onClose}
                        style={{
                            background: 'rgba(255,255,255,0.15)', border: 'none', width: '40px', height: '40px', borderRadius: '50%',
                            fontSize: '1.5rem', cursor: 'pointer', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            transition: 'background 0.3s'
                        }}
                    >
                        &times;
                    </button>
                </div>

                {/* Body (Timeline) */}
                <div style={{ padding: '35px 30px', overflowY: 'auto', backgroundColor: '#fcfcfc' }}>
                    <div style={{ position: 'relative', paddingLeft: '45px', margin: '10px 0' }}>
                        {/* Vertical line gradient */}
                        <div style={{ position: 'absolute', left: '11px', top: '10px', bottom: '15px', width: '4px', borderRadius: '2px', background: 'linear-gradient(to bottom, #d4d4d4 0%, #f0f0f0 100%)' }}></div>

                        {reversedBoleto.map((Objeto, index) => {
                            const nodeColor = getStatusColor(Objeto.EstatusID);
                            
                            // Formato de hora a 12h (AM/PM)
                            let horaFormateada = Objeto.Hora;
                            if (horaFormateada) {
                                const partes = horaFormateada.split(':');
                                if (partes.length >= 2) {
                                    let h = parseInt(partes[0], 10);
                                    const m = partes[1];
                                    const ampm = h >= 12 ? 'PM' : 'AM';
                                    h = h % 12 || 12;
                                    horaFormateada = `${h.toString().padStart(2, '0')}:${m} ${ampm}`;
                                }
                            }

                            return (
                                <div key={index} style={{ position: 'relative', marginBottom: index === reversedBoleto.length - 1 ? 0 : '45px' }}>
                                    {/* Timeline Dot Flat */}
                                    <div style={{
                                        position: 'absolute',
                                        left: '-41px',
                                        top: '4px',
                                        width: '22px',
                                        height: '22px',
                                        borderRadius: '50%',
                                        backgroundColor: nodeColor,
                                        border: '4px solid #fcfcfc',
                                        zIndex: 2
                                    }}></div>
                                    
                                    {/* Content Card Flat */}
                                    <div style={{
                                        background: '#ffffff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        border: '1px solid #eaeaea',
                                        position: 'relative'
                                    }}>
                                        {/* Fecha/Hora Badge */}
                                        <div style={{position: 'absolute', top: '20px', right: '20px', textAlign: 'right'}}>
                                            <div style={{fontSize: '14px', color: '#888', fontWeight: 'bold'}}><i className="fa fa-calendar" style={{marginRight: '6px'}}></i>{Objeto.Fecha}</div>
                                            <div style={{fontSize: '14px', color: '#aaa', marginTop: '4px'}}><i className="fa fa-clock-o" style={{marginRight: '6px'}}></i>{horaFormateada}</div>
                                        </div>

                                        <div style={{
                                            display: 'inline-block',
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            backgroundColor: `${nodeColor}15`, 
                                            color: nodeColor,
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            marginBottom: '15px'
                                        }}>
                                            {Objeto.Estatus} <span style={{ opacity: 0.7 }}>({Objeto.EstatusID})</span>
                                        </div>
                                        
                                        {Objeto.Comentario && (
                                            <div style={{
                                                background: '#f8f9fa',
                                                padding: '15px 20px',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                color: '#444',
                                                lineHeight: '1.6'
                                            }}>
                                                {Objeto.Comentario}
                                            </div>
                                        )}
                                        {!Objeto.Comentario && (
                                            <div style={{ color: '#aaa', fontSize: '14px', fontStyle: 'italic' }}>{t('respuesta.sinComentarios', 'Sin comentarios adicionales.')}</div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Footer */}
                <div style={{ padding: '20px 30px', borderTop: '1px solid #f0f0f0', textAlign: 'right', backgroundColor: '#ffffff' }}>
                    <button 
                        onClick={onClose}
                        style={{
                            background: '#cd171a', color: '#fff', border: 'none', padding: '10px 30px', fontSize: '1.05rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold'
                        }}
                    >
                        {t('respuesta.cerrar', 'Cerrar')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RespuestaC;